export const genderDetail={
    F:'Femenino',
    M:'Masculino'
}